/**
 * useFetchOnce
 * Ensures a fetch function runs only once per mount, despite React
 * Strict Mode double-invocations or dependency re-evaluations.
 *
 * Usage:
 *   const fetchOnce = useFetchOnce(() => fetchBusiness(), [id]);
 *   useEffect(() => { fetchOnce(); }, [fetchOnce]);
 */

import { useRef, useCallback } from 'react';

export const useFetchOnce = (fetchFn, dependencies = []) => {
    const fetchedRef = useRef(false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const executeOnce = useCallback(async () => {
        if (fetchedRef.current) return;
        fetchedRef.current = true;
        return fetchFn();
    }, dependencies);

    return executeOnce;
};
